import styled from 'styled-components';
import { SIZE } from '@app/src/ui';
import { getImageByAlias, getColorRgbByAlias } from '@app/src/utils/categories';

interface Props {
  alias: string;
}

export const WrapperStep = styled.div`
  width: 100%;
  display: flex;
  position: relative;
`;

export const WrapperStepLeft = styled.div`
  position: relative;
  background-image: ${(props:Props) => props.alias && `url(${getImageByAlias(props.alias)})`};
  background-position: top center;
  background-size: cover;
  background-repeat: no-repeat;
  display: none;
  width: 35%;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    display: block;
    min-height: calc(100vh - 70px);
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: ${(props: Props) => `rgba(${getColorRgbByAlias(props.alias)}, .5)`};
  width: 100%;
  height: 100%;
`;

export const WrapperStepRight = styled.div`
  padding: 30px 15px 0;
  width: 100%;
  background: #fff;
  min-height: calc(100vh - 56px);

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    min-height: calc(100vh - 70px);
    padding: 5% 5% 0 5%;
    width: 65%;
    height: auto;
  }
`;

export const Container = styled.div`
  margin: auto;
  flex-direction: column;
  height: 100%;
  display: flex;
  justify-content: space-between;
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin-left: 10%;
    max-width: 480px;
  }
`;

export const Wrapper = styled.div`
  height: 100%;
`;
